import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { inject } from 'mobx-react';
import * as React from 'react';
import { STORE_COMMON } from '../constants';
import { CommonStore } from '../stores';

interface IProps {
    commonStore: CommonStore
}
@inject(STORE_COMMON)
export class Footer extends React.Component<IProps> {

    private ScrollToTop = () => {
        this.props.commonStore.scrollTop();
    }
    public render() {
        return <footer className="page-footer font-small" >
            <button className='btn btn-info btn-sm top-button' onClick={this.ScrollToTop}><FontAwesomeIcon icon="arrow-up" /></button>
        </footer>;
    }
}
